export default __webpack_public_path__ + "static/media/atthegates.efab23c1.png";